import T from "react";
var l = { exports: {} }, y = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L;
function A() {
  if (L) return y;
  L = 1;
  var i = T;
  function _(t, o) {
    return t === o && (t !== 0 || 1 / t === 1 / o) || t !== t && o !== o;
  }
  var c = typeof Object.is == "function" ? Object.is : _, p = i.useState, u = i.useEffect, S = i.useLayoutEffect, E = i.useDebugValue;
  function O(t, o) {
    var e = o(), n = p({ inst: { value: e, getSnapshot: o } }), r = n[0].inst, a = n[1];
    return S(
      function() {
        r.value = e, r.getSnapshot = o, f(r) && a({ inst: r });
      },
      [t, e, o]
    ), u(
      function() {
        return f(r) && a({ inst: r }), t(function() {
          f(r) && a({ inst: r });
        });
      },
      [t]
    ), E(e), e;
  }
  function f(t) {
    var o = t.getSnapshot;
    t = t.value;
    try {
      var e = o();
      return !c(t, e);
    } catch {
      return !0;
    }
  }
  function v(t, o) {
    return o();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? v : O;
  return y.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : d, y;
}
var m = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x;
function R() {
  return x || (x = 1, process.env.NODE_ENV !== "production" && function() {
    function i(e, n) {
      return e === n && (e !== 0 || 1 / e === 1 / n) || e !== e && n !== n;
    }
    function _(e, n) {
      d || u.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var r = n();
      if (!t) {
        var a = n();
        S(r, a) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), t = !0);
      }
      a = E({
        inst: { value: r, getSnapshot: n }
      });
      var s = a[0].inst, h = a[1];
      return f(
        function() {
          s.value = r, s.getSnapshot = n, c(s) && h({ inst: s });
        },
        [e, r, n]
      ), O(
        function() {
          return c(s) && h({ inst: s }), e(function() {
            c(s) && h({ inst: s });
          });
        },
        [e]
      ), v(r), r;
    }
    function c(e) {
      var n = e.getSnapshot;
      e = e.value;
      try {
        var r = n();
        return !S(e, r);
      } catch {
        return !0;
      }
    }
    function p(e, n) {
      return n();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var u = T, S = typeof Object.is == "function" ? Object.is : i, E = u.useState, O = u.useEffect, f = u.useLayoutEffect, v = u.useDebugValue, d = !1, t = !1, o = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : _;
    m.useSyncExternalStore = u.useSyncExternalStore !== void 0 ? u.useSyncExternalStore : o, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), m;
}
var w;
function g() {
  return w || (w = 1, process.env.NODE_ENV === "production" ? l.exports = A() : l.exports = R()), l.exports;
}
var G = g();
export {
  G as s
};
//# sourceMappingURL=index-BLPblar-.js.map
